/**
 * user-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message, ReplyVerifyingMessage } from "../general/";
import { MessageTag } from "../message-tag";

export class UserRequest extends ReplyVerifyingMessage
{
	/** The unique tag for this message type */
	public tag : MessageTag = MessageTag.REQ_USER;
	public static tag : MessageTag = MessageTag.REQ_USER;

  /**
   * Construct a new {@link UserRequest}.
   */
  constructor (
    public recordId : number
  )
  {
    super();
  }

  public verifyReply (reply : Message) : boolean
  {
	  return Message.isA(reply, MessageTag.RSP_USER);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/group-management/user-request.ts